import React, {
	useEffect,
	useRef,
	useState
} from 'react'

import {
	PDFReceiverMessages,
	PdfSenderMessages,
	ReceiverTextMessages,
	RecevicerImageMessage,
	SenderImageMessage,
	SenderTextMessages
} from './messages'

import {
	useCustomDispatch,
	useCustomNavigate
} from '../../hooks'

import {
	currentTime
} from '../../utils/helper/helper'

import {
	subScribeChatNotifications,
	subscribeGroupMessages
} from '../../utils/miscellaneous/ably'

import {
	useCustomDataStoringStates,
	useCustomLoadingStates,
	useCustomNullStates
} from '../../hooks/customStates'

import {
	closeOverlay,
	handleFileSelect,
	hanlePdfSelect,
	onhandleImageChange,
	onhandlePdfFileChange,
	playMessageSound
} from '../../assets/js/custome'

import { useParams } from 'react-router-dom'
import { initiatedChatGroup } from '../../services/actions/chat/initiateChatGroupActions'
import { useCustomSelectors } from '../../services/selectors/allSelectors'
import { initatedGroupId } from '../../storage'

import { addMessagesToGroup } from '../../services/actions/chat/addChatGroupMessagesActions'
import { addReadMessages } from '../../services/actions/chat/chatReadUnReadMessages'
import { fecthAllGroupPreviousMessages } from '../../services/actions/chat/getChatPreviousMessagesActions'
import { fetchAllRecentChats } from '../../services/actions/chat/recentChatsListsActions'
// import { renderMessagesByDate } from '../../utils/helper/chatsHelper'

import EmojiPicker from "emoji-picker-react"
import Cookies from 'js-cookie'
import ChatLoader from '../common/chatLoader'

import * as audio from '../../assets/images/index'
import * as routesNames from '../../routes/routeName'

const getValidPhoto = (photo) => {
	const value = String(photo || '').trim()
	return value && !['null', 'undefined'].includes(value.toLowerCase()) ? value : ''
}

const getInitials = (value) => {
	const name = String(value || '').trim()
	if (!name) return 'U'

	const parts = name.split(/\s+/).filter(Boolean)
	if (parts.length === 1) {
		return parts[0].slice(0, 2).toUpperCase()
	}

	return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}

const ResponsiveChatView = () => {

	const { user_id } = useParams()
	const chatBodyRef = useRef(null);

	const navigate = useCustomNavigate()
	const dispatch = useCustomDispatch()

	const userId = parseInt(user_id)
	const chatGroupID = initatedGroupId()
	const loadPreviousMessage = Cookies.get('previous')
	const [headerAvatarFailed, setHeaderAvatarFailed] = useState(false)

	const {
		profileData,
		pharmacyIntiatedChatResponse,
		initatedChatMessagesResponse,
		recentChatList,
		pharmacyId } = useCustomSelectors()

	const {
		mediaFile,
		setMediaFile,
		mediaPdf,
		setMediaPdf,
		chatAppenedMessages,
		setChatAppenedMessages,
		myInputMessages,
		setMyInputMessages,
		allGroupMessages,
		setAllGroupMessages,
	} = useCustomDataStoringStates()

	const {
		apiCallMade,
		setApiCallMade,
		showEmojiLoader,
		setShowEmojiLoader,
		loadGroupMessages,
		setLoadGroupMessages,
	} = useCustomLoadingStates()

	const {
		overlayImage,
		setOverlayImage
	} = useCustomNullStates()


	const recentChatsResponse = recentChatList?.data?.latest_messages
	const chatUser = pharmacyIntiatedChatResponse?.data?.data?.users?.find((value) => value?.group_id === userId)
	const userOnlineStatus = recentChatsResponse?.find((value) => value?.group_id === userId)
	const headerAvatarUrl = getValidPhoto(userOnlineStatus?.thumbnail)
	const headerDisplayName = userOnlineStatus?.name || 'User'
	const shouldShowHeaderAvatarImage = headerAvatarUrl && !headerAvatarFailed

	const [chatInput, setChatInput] = useState('')

	useEffect(() => {
		if (!apiCallMade && userId) {
			dispatch(initiatedChatGroup(userOnlineStatus?.group_type, userOnlineStatus?.user_id, userOnlineStatus))
			setApiCallMade(true)
		}
	}, [userId])

	const loadPreviousMessages = async () => {
		const lastMessageId = allGroupMessages?.length > 0 ? allGroupMessages[0]?.id : null;
		if (chatGroupID && lastMessageId && initatedChatMessagesResponse?.length >= 20 && loadPreviousMessage !== 'empty') {
			await fecthAllGroupPreviousMessages(chatGroupID, lastMessageId, setAllGroupMessages, allGroupMessages, setLoadGroupMessages, chatBodyRef);
		}
	}

	const handleScroll = async () => {
		const chatBody = chatBodyRef.current;

		if (chatBody.scrollTop === 0) {
			await loadPreviousMessages();
		}
	}

	const handleChatMessages = (e) => {
		setChatInput(e.target.value)
	}

	function handleEmojies(emojiData) {
		setChatInput((chatInput) => chatInput + (emojiData.isCustom ? emojiData.unified : emojiData.emoji))
	}

	const submitMessages = async (e, value, mediaFile) => {
		e.preventDefault()
		const checkMessageCount = recentChatsResponse?.find((list) => list?.user_id === value?.user_id)
		if ((chatInput || mediaFile?.length !== 0 || mediaPdf?.length !== 0) && chatGroupID) {
			dispatch(addMessagesToGroup(chatInput, 'text', chatGroupID, mediaFile, mediaPdf))
			setMyInputMessages([...myInputMessages, { message: chatInput, sender: 'user', time: currentTime, message_media: mediaFile, media_pdf: mediaPdf }])
			setChatInput('')
			setMediaFile([])
			setMediaPdf([])
		}

		if (chatGroupID && checkMessageCount?.unread_count !== 0) {
			await (addReadMessages(chatGroupID))
			dispatch(fetchAllRecentChats())
		}
	}


	const chatkeyPress = (e, value) => {
		if (e.key === 'Enter') {
			submitMessages(e, value, mediaFile)
		}
	}

	const handleFileChange = (event) => {
		onhandleImageChange(event, setMediaFile, mediaFile)
	}


	const handlePdfFileChange = (event) => {
		onhandlePdfFileChange(event, setMediaPdf, mediaPdf)
	}


	useEffect(() => {
		setAllGroupMessages(initatedChatMessagesResponse)
	}, [pharmacyIntiatedChatResponse])

	useEffect(() => {
		if (chatBodyRef.current && allGroupMessages?.length <= 25) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [myInputMessages,
		initatedChatMessagesResponse,
		chatAppenedMessages,
		allGroupMessages])

	useEffect(() => {
		if (chatBodyRef.current) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [myInputMessages,
		chatAppenedMessages])

	useEffect(() => {
		setHeaderAvatarFailed(false)
	}, [headerAvatarUrl, userId])


	useEffect(() => {
		const ablyConnection = subscribeGroupMessages(
			chatGroupID,
			setChatAppenedMessages,
			setMyInputMessages,
			playMessageSound,
			profileData,
			dispatch)

		return () => {
			ablyConnection.close();
		};
	}, [chatGroupID, dispatch])

	useEffect(() => {
		const ablyConnection = subScribeChatNotifications(pharmacyId,
			profileData?.user_id,
			dispatch,
			playMessageSound)

		return () => {
			ablyConnection.close();
		};
	}, [profileData])


	function openOverlay(image) {
		document.getElementById('overlay').style.display = 'flex';
		setOverlayImage(image)
	}

	const handleRemoveImage = (indexToRemove) => {
		const updatedMediaFiles = mediaFile.filter((_, index) => index !== indexToRemove);
		setMediaFile(updatedMediaFiles);
	};

	const handleRemovePdf = (indexToRemove) => {
		const updatedMediaFiles = mediaPdf?.filter((_, index) => index !== indexToRemove);
		setMediaPdf(updatedMediaFiles);
	};


	return (
		<>
			<audio id="messageSound">
				<source src={audio.chatAudio} type="audio/mpeg" />
			</audio>

			<div className='hidden sm:block md:hidden lg:block xl:block'>
				<div className='flex items-center justify-center h-screen'>
					<div className='bg-gradient-to-r from-blue-400 to-purple-500 rounded-lg p-8 shadow-xl'>
						<h2 className='text-4xl font-bold text-white mb-4'>Oops!</h2>
						<p className='text-lg text-white'>Seems like you've wandered off the path.</p>
						<p className='text-lg text-white mt-2'>Let's get you back on track!</p>
					</div>
				</div>
			</div>

			<div className="relative w-full h-screen overflow-hidden place-items-center mx-auto lg:hidden">
				<div className="relative bg-white h-full overflow-hidden dark:bg-gray-700">

					<div className="flex items-center justify-between p-2 md:p-2 border-b rounded-t dark:border-gray-600">
						<h3 className="flex items-center gap-3 dark-color rubik-500 fs-18">
							<svg className='btnnn' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(routesNames.NEWREQUEST_ROUTE)}>
								<path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" fill="#757575" />
							</svg>

							{pharmacyIntiatedChatResponse?.loading ?
								<div className="flex items-start gap-3 p-1 pt-2 pb-0">
									<svg className="w-12 h-12  text-gray-300 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
										<path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
									</svg>
									<div className="rounded-md">
										<div className="h-12 rounded-54 bg-gray-300 dark:bg-gray-700 w-32 mb-3" style={{ borderRadius: '4px' }}></div>
									</div>
								</div> :
								<>
									<div className="relative">
										{shouldShowHeaderAvatarImage ? (
											<img
												className="w-10 h-10 rounded-full bg-light object-cover"
												src={headerAvatarUrl}
												onError={() => setHeaderAvatarFailed(true)}
												alt="Rounded avatar"
											/>
										) : (
											<span className="flex w-10 h-10 items-center justify-center rounded-full bg-slate-200 text-sm font-semibold text-slate-600">
												{getInitials(headerDisplayName)}
											</span>
										)}

										{
											userOnlineStatus?.online_status === 'online' ?
												<span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-green-500 border-2 border-white dark:border-gray-800 rounded-full"></span>
												:
												userOnlineStatus?.online_status === 'offline' ?
													<span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-red-500 border-2 border-white dark:border-gray-800 rounded-full"></span>
													:
													userOnlineStatus?.online_status === 'idle' ?
														<span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-yellow-500 border-2 border-white dark:border-gray-800 rounded-full"></span>
														: null
										}

									</div>
									{headerDisplayName}
								</>
							}
						</h3>
					</div>
					<div className="h-screen overflow-y-auto space-y-4 pb-56 scroll-box js-chatbox-display" ref={chatBodyRef} onScroll={handleScroll} >
						{
							loadGroupMessages &&
							<div className="flex items-center justify-center mt-2">
								<div className="flex items-center">
									<ChatLoader />
								</div>
							</div>
						}

						{pharmacyIntiatedChatResponse?.loading && (
							<div className="support-chat-loading">Loading conversation...</div>
						)}

						{/* {renderMessagesByDate(allGroupMessages, profileData, chatUser, openOverlay)} */}

						{
							chatAppenedMessages?.length === 0 ? null :
								chatAppenedMessages?.map((msglist, index) => {
									return (
										<React.Fragment key={index}>
											{
												msglist.user_id === profileData.user_id && <>

													{
														msglist?.message_text === null ? null :
															<SenderTextMessages profileData={profileData} textMessage={msglist.message_text} time={msglist?.date_and_time?.slice(12)} />
													}

													{
														msglist?.message_media?.length === 0 ? null :
															<>
																{msglist.message_media?.map((msgListImage, index) => {
																	return (
																		<React.Fragment key={index}>
																			<SenderImageMessage profileData={profileData} image={msgListImage} openOverlay={openOverlay} time={msglist?.date_and_time?.slice(12)} />
																		</React.Fragment>
																	)
																})}
															</>
													}

													{
														msglist?.media_pdf?.length === 0 ? null : <>{
															msglist?.media_pdf?.map((pdf, index) => {
																return (
																	<React.Fragment key={index}>
																		<PdfSenderMessages profileData={profileData} pdf={pdf} time={msglist?.date_and_time?.slice(12)} />
																	</React.Fragment>
																)
															})
														}
														</>
													}
												</>
											}

											{
												msglist?.user_id !== profileData?.user_id && <>
													{
														msglist?.message_text === null ? null :
															<ReceiverTextMessages chatUser={chatUser} textMessage={msglist.message_text} time={msglist?.date_and_time?.slice(12)} />
													}

													{
														msglist?.message_media?.length === 0 ? null : <>
															{
																msglist.message_media?.map((msgListImage, index) => {
																	return (
																		<React.Fragment key={index}>
																			<RecevicerImageMessage chatUser={chatUser} time={msglist?.date_and_time?.slice(12)} openOverlay={openOverlay} image={msgListImage} />
																		</React.Fragment>
																	)
																})
															}</>
													}

													{
														msglist?.media_pdf?.length === 0 ? null : <>{
															msglist?.media_pdf?.map((pdfFile, index) => {
																return (
																	<React.Fragment key={index}>
																		<PDFReceiverMessages chatUser={chatUser} pdf={pdfFile} time={msglist?.date_and_time?.slice(12)} />
																	</React.Fragment>
																)
															})
														}
														</>
													}

												</>
											}

										</React.Fragment>
									)
								})
						}

						{
							(profileData?.user_id !== chatUser?.user_id) && <>
								{myInputMessages?.map((msg, index) => {
									return (<React.Fragment key={index}>
										{
											msg?.message === '' ? null :
												<SenderTextMessages profileData={profileData} textMessage={msg.message} time={msg.time} />
										}

										{
											msg?.message_media?.length === 0 ? null : <>{
												msg?.message_media?.map((imageValue, index) => {
													return (
														<React.Fragment key={index} >
															<SenderImageMessage profileData={profileData} image={URL.createObjectURL(imageValue)} openOverlay={openOverlay} time={msg.time} />
														</React.Fragment>
													)
												})
											}
											</>
										}

										{
											msg?.media_pdf?.length === 0 ? null : <>{
												msg?.media_pdf?.map((pdf, index) => {
													return (
														<React.Fragment key={index}>
															<PdfSenderMessages time={msg?.time} profileData={profileData} pdf={pdf} />
														</React.Fragment>
													)
												})
											}
											</>
										}
									</React.Fragment>)
								})
								}
							</>
						}

					</div>

					<div className="chat-footer fixed bottom-0 left-0 w-full">
						<div className="relative bg-white border-t">
							<textarea id="message" onChange={handleChatMessages} value={chatInput} onKeyPress={(e) => chatkeyPress(e, chatUser)} rows="4" className="bg-light rubik-400 fs-16 block p-2.5 w-full text-sm text-gray-900 bg-gray-50 resize-none border-none focus:ring-gray-50 focus:border-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" placeholder="Write message..."></textarea>

							{mediaPdf?.length !== 0 &&
								<div className="image-containe bg-light" style={{ display: 'flex', flexWrap: 'wrap' }}>
									{mediaPdf?.map((value, index) => {
										return (
											<a className="btnnn rubik-400 fs-16 m-2 dark-color uppercase red-color underline flex gap-2" key={index}>
												<div className='relative'>
													<div className="close-btn" style={{ position: 'absolute', right: '-1px', top: '-2px', cursor: 'pointer', color: 'black', borderColor: 'black' }}
														onClick={() => handleRemovePdf(index)}>
														×
													</div>
													<svg width="50" height="50" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
														<g clipPath="url(#clip0_57_2-751433)">
															<path d="M19.9021 6.47316L13.7129 0.10102C13.6501 0.0365918 13.5655 0 13.477 0H6.46633C4.8347 0 3.50728 1.36692 3.50728 3.04655V9.07545H0.910023C0.408235 9.07545 0 9.49569 0 10.0122V15.3971C0 15.9136 0.408235 16.3339 0.910023 16.3339H3.50707V18.9537C3.50728 20.6331 4.83448 22 6.46633 22H17.041C18.6726 22 20 20.6331 20 18.9534V6.71651C19.9998 6.62537 19.9647 6.53759 19.9021 6.47316ZM3.00179 14.5478V10.8624C3.00179 10.6725 3.15117 10.5187 3.33566 10.5187H4.41142C5.1882 10.5187 5.82061 11.1697 5.82061 11.9693V12.0158C5.82061 12.8159 5.1882 13.4665 4.41142 13.4665H3.66931V14.5481C3.66931 14.738 3.51993 14.8918 3.33588 14.8918C3.15117 14.8918 3.00179 14.7378 3.00179 14.5478ZM6.59761 14.5478V10.8624C6.59761 10.6725 6.74699 10.5187 6.93104 10.5187H8.0068C8.78402 10.5187 9.416 11.1697 9.416 11.9693V13.4411C9.416 14.2407 8.78402 14.8918 8.0068 14.8918H6.93104C6.74721 14.8918 6.59761 14.7378 6.59761 14.5478ZM12.4782 12.1584C12.6627 12.1584 12.8121 12.3121 12.8121 12.5016C12.8121 12.6915 12.6627 12.8453 12.4782 12.8453H10.927V14.5478C10.927 14.7378 10.7777 14.8915 10.5936 14.8915C10.4091 14.8915 10.2597 14.7378 10.2597 14.5478V10.8624C10.2597 10.6725 10.4091 10.5187 10.5936 10.5187H12.7445C12.9285 10.5187 13.0779 10.6725 13.0779 10.8624C13.0779 11.0519 12.9285 11.2056 12.7445 11.2056H10.927V12.1581L12.4782 12.1584ZM19.3325 18.9534C19.3325 20.2546 18.3045 21.3128 17.041 21.3128H6.46633C5.20281 21.3128 4.17481 20.2546 4.17481 18.9534V16.3337H15.169C15.6708 16.3337 16.079 15.9134 16.079 15.3969V10.0122C16.079 9.49569 15.6708 9.07545 15.169 9.07545H4.17459V3.04655C4.17459 1.74541 5.20259 0.687163 6.46611 0.687163H13.1429V6.02822C13.1429 6.59708 13.5921 7.05998 14.1438 7.05998H19.3323L19.3325 18.9534ZM4.41142 12.7793H3.66931V11.2059H4.41142C4.82053 11.2059 5.15309 11.5484 5.15309 11.9693V12.0158C5.15309 12.437 4.82031 12.7793 4.41142 12.7793ZM8.0068 14.2046H7.26513V11.2059H8.0068C8.41591 11.2059 8.74847 11.5484 8.74847 11.9693V13.4411C8.74869 13.8622 8.41591 14.2046 8.0068 14.2046Z" fill="#FA3737" />
														</g>
														<defs>
															<clipPath id="clip0_57_2-751433">
																<rect width="20" height="22" fill="white" />
															</clipPath>
														</defs>
													</svg>
												</div>

											</a>
										)
									})}
								</div>}

							{mediaFile?.length !== 0 ? (
								<div className="image-container bg-light" style={{ display: 'flex', flexWrap: 'wrap' }}>
									{mediaFile?.map((value, index) => (
										<div key={index} style={{ position: 'relative' }}>
											<div className="close-btn" style={{ position: 'absolute', right: '5px', top: '5px', cursor: 'pointer' }} onClick={() => handleRemoveImage(index)}>
												×
											</div>
											<img src={URL.createObjectURL(value)} alt="Selected" className='rounded-2 h-12 w-12 m-2' />
										</div>
									))}
								</div>
							) : null}


							<button className="absolute right-4 top-5" onClick={(e) => submitMessages(e, chatUser, mediaFile)}>
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_100_30-273094)">
										<path d="M11.8725 19.9999C12.3626 20.0041 12.8419 19.8561 13.2443 19.5762C13.6466 19.2963 13.9523 18.8984 14.119 18.4374L19.8438 3.27106C20.0081 2.83653 20.0437 2.36384 19.9463 1.90961C19.8489 1.45537 19.6227 1.03885 19.2947 0.70993C18.9667 0.381009 18.5509 0.153635 18.0971 0.0550427C17.6432 -0.0435501 17.1706 -0.00918169 16.7358 0.154031L1.55808 5.8565C1.0731 6.04071 0.660283 6.37621 0.380731 6.81335C0.101178 7.25048 -0.0302608 7.76603 0.00586632 8.2837C0.0419934 8.80137 0.243764 9.29365 0.581321 9.6877C0.918878 10.0817 1.37429 10.3566 1.88015 10.4716L7.62112 11.7603C7.77079 11.7935 7.90789 11.8687 8.01629 11.9772C8.12469 12.0856 8.19989 12.2227 8.23306 12.3725L9.50525 18.083C9.61853 18.5913 9.89293 19.0493 10.2876 19.389C10.6822 19.7286 11.176 19.9316 11.6953 19.9677L11.8725 19.9999Z" fill="#3A52BB" />
									</g>
									<defs>
										<clipPath id="clip0_100_30-273094">
											<rect width="20" height="20" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</button>
						</div>

						<div className="flex items-center gap-4 p-3 footerIcon border-t">
							<button onClick={handleFileSelect}>
								<div id="upload-container" className="bg-gray-200">
									<svg id="upload-image" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clipPath="url(#clip0_100_20-248074)">
											<path fillRule="evenodd" clipRule="evenodd" d="M0.269024 15.7778C0.221909 15.5434 0.183044 15.2948 0.150987 15.0299C0 13.7826 0 12.1752 0 10C0 5.83362 1.19209e-07 3.75044 1.06102 2.29009C1.40369 1.81844 1.81844 1.40369 2.29009 1.06102C3.75044 1.19209e-07 5.83362 0 10 0C14.1664 0 16.2496 1.19209e-07 17.7099 1.06102C18.1816 1.40369 18.5963 1.81844 18.939 2.29009C20 3.75044 20 5.83362 20 10C20 12.2063 20 13.8285 19.8424 15.0833C19.8117 15.3282 19.7749 15.5592 19.731 15.7778C19.575 16.5539 19.3284 17.1739 18.939 17.7099C18.5963 18.1816 18.1816 18.5963 17.7099 18.939C16.2496 20 14.1664 20 10 20C5.83362 20 3.75044 20 2.29009 18.939C1.81844 18.5963 1.40369 18.1816 1.06102 17.7099C0.671551 17.1739 0.425047 16.5539 0.269024 15.7778ZM18.8253 13.9945C18.8868 12.9738 18.8889 11.6883 18.8889 10C18.8889 7.89207 18.8874 6.40036 18.7627 5.24998C18.6403 4.12038 18.41 3.45238 18.0401 2.94318C17.7659 2.56587 17.4341 2.23407 17.0568 1.95993C16.5476 1.58996 15.8796 1.35967 14.75 1.23727C13.5996 1.11264 12.1079 1.11111 10 1.11111C7.89207 1.11111 6.40036 1.11264 5.24998 1.23727C4.12038 1.35967 3.45238 1.58996 2.94318 1.95993C2.56587 2.23407 2.23407 2.56587 1.95993 2.94318C1.58996 3.45238 1.35967 4.12038 1.23727 5.24998C1.11264 6.40036 1.11111 7.89207 1.11111 10C1.11111 11.555 1.11291 12.7683 1.16122 13.7478L2.88351 11.5619C3.45491 10.8367 3.91282 10.2555 4.32544 9.83762C4.74918 9.40847 5.1792 9.09371 5.7124 8.97318C6.06147 8.89427 6.42251 8.88356 6.77567 8.94162C7.31507 9.03036 7.763 9.31907 8.21142 9.72236C8.64809 10.1151 9.13967 10.6681 9.75304 11.3582L9.983 11.6169C10.1581 11.8139 10.2713 11.9408 10.3644 12.0323C10.454 12.1203 10.4966 12.1464 10.5189 12.1573C10.6515 12.2222 10.8046 12.2316 10.9442 12.1835C10.9676 12.1754 11.0131 12.1548 11.1128 12.0784C11.2165 11.9991 11.3444 11.887 11.5424 11.713L11.5569 11.7003C11.9208 11.3805 12.2146 11.1223 12.4683 10.9278C12.7294 10.7276 12.9783 10.5706 13.2597 10.4717C13.9449 10.2308 14.6972 10.2678 15.3554 10.5749C15.6258 10.701 15.858 10.8817 16.0982 11.1066C16.3315 11.3251 16.5986 11.6109 16.9292 11.9649L18.8253 13.9945ZM13.2222 6C13.2222 6.55229 13.6699 7 14.2222 7C14.7745 7 15.2222 6.55229 15.2222 6C15.2222 5.44771 14.7745 5 14.2222 5C13.6699 5 13.2222 5.44771 13.2222 6ZM14.2222 8.11111C13.0563 8.11111 12.1111 7.16593 12.1111 6C12.1111 4.83407 13.0563 3.88889 14.2222 3.88889C15.3882 3.88889 16.3333 4.83407 16.3333 6C16.3333 7.16593 15.3882 8.11111 14.2222 8.11111Z" fill="#757575" />
										</g>
										<defs>
											<clipPath id="clip0_100_20-248074">
												<rect width="20" height="20" fill="white" />
											</clipPath>
										</defs>
									</svg>
									<input type="file" accept="image/*" id="chatFileInput" style={{ display: 'none' }} onChange={handleFileChange} />
								</div>
							</button>

							<button onClick={hanlePdfSelect}>
								<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_100_22-023736)">
										<path d="M5.22497 14.5425C4.55761 14.5425 3.89025 14.3704 3.29497 14.0263C2.85548 13.7728 2.50669 13.424 1.81374 12.7311C1.11847 12.0358 0.772003 11.6893 0.516219 11.2475C-0.172073 10.057 -0.172073 8.57807 0.516219 7.38751C0.769678 6.94803 1.11847 6.59923 1.81142 5.90629L4.54133 3.17637C5.23428 2.48343 5.58307 2.13464 6.02256 1.88118C7.21312 1.19288 8.69201 1.19288 9.88257 1.88118C10.3221 2.13464 10.6709 2.48343 11.3638 3.17637C12.0567 3.86932 12.4055 4.21811 12.659 4.6576C13.3473 5.84816 13.3473 7.32706 12.659 8.51762C12.5195 8.75712 12.3428 8.98733 12.0614 9.28729C11.6986 9.67795 11.0871 9.69655 10.6964 9.3338C10.3058 8.97105 10.2849 8.35949 10.6499 7.96884C10.8243 7.78282 10.9243 7.65725 10.9848 7.55261C11.3289 6.95733 11.3289 6.21788 10.9848 5.6226C10.8569 5.4017 10.5523 5.09708 9.99651 4.54133C9.44076 3.98558 9.13382 3.67864 8.91292 3.55075C8.31764 3.2066 7.57819 3.2066 6.98291 3.55075C6.762 3.67864 6.45739 3.98326 5.90164 4.53901L3.17172 7.26892C2.61598 7.82467 2.30903 8.13161 2.18347 8.35019C1.83932 8.94547 1.83932 9.68492 2.18347 10.2802C2.31136 10.5011 2.61598 10.8057 3.17172 11.3615C3.72747 11.9172 4.03442 12.2242 4.25299 12.3497C4.84827 12.6939 5.58772 12.6939 6.183 12.3497C6.28997 12.2893 6.41321 12.1893 6.60156 12.0149C6.99221 11.6521 7.60144 11.6731 7.96652 12.0614C8.32926 12.452 8.30834 13.0613 7.92001 13.4263C7.62004 13.7054 7.38984 13.8844 7.15033 14.024C6.55505 14.3681 5.88769 14.5402 5.22032 14.5402L5.22497 14.5425ZM12.0498 13.1775C11.3824 13.1775 10.715 13.0055 10.1198 12.6613C9.68027 12.4079 9.33147 12.0591 8.63853 11.3661C7.94559 10.6732 7.59679 10.3244 7.34101 9.88257C6.65272 8.69201 6.65272 7.21312 7.34101 6.02256C7.48053 5.78305 7.65725 5.55284 7.93861 5.25288C8.30136 4.86223 8.91292 4.84362 9.30357 5.20637C9.69422 5.56912 9.71282 6.18068 9.35008 6.57133C9.17568 6.75735 9.07569 6.88292 9.01523 6.98756C8.67109 7.58284 8.67109 8.32229 9.01523 8.91757C9.14312 9.13847 9.44774 9.44309 10.0035 9.99884C10.5592 10.5546 10.8662 10.8615 11.0848 10.9871C11.68 11.3312 12.4195 11.3312 13.0148 10.9871C13.2357 10.8592 13.5403 10.5546 14.096 9.99884L16.826 7.26892C17.3817 6.71317 17.6886 6.40623 17.8142 6.18765C18.1584 5.59237 18.1584 4.85292 17.8142 4.25764C17.6863 4.03674 17.3817 3.73212 16.826 3.17637C16.2702 2.62063 15.9633 2.31368 15.7447 2.18812C15.1494 1.84397 14.41 1.84397 13.8147 2.18812C13.7077 2.24858 13.5845 2.34856 13.3961 2.52529C13.0055 2.88804 12.3962 2.86711 12.0312 2.47878C11.6684 2.08813 11.6893 1.4789 12.0777 1.11382C12.3776 0.834787 12.6078 0.655738 12.8473 0.516219C14.0379 -0.172073 15.5168 -0.172073 16.7074 0.516219C17.1468 0.769678 17.4956 1.11847 18.1886 1.81142C18.8815 2.50436 19.2303 2.85316 19.4838 3.29264C20.1721 4.4832 20.1721 5.9621 19.4838 7.15266C19.2303 7.59214 18.8815 7.94094 18.1886 8.63388L15.4587 11.3638C14.7657 12.0567 14.4169 12.4055 13.9774 12.659C13.3822 13.0031 12.7148 13.1752 12.0474 13.1752L12.0498 13.1775Z" fill="#757575" />
									</g>
									<defs>
										<clipPath id="clip0_100_22-023736">
											<rect width="20" height="15" fill="white" />
										</clipPath>
									</defs>
								</svg>

								<input type="file" accept="application/pdf" multiple id="chatPdfInput" style={{ display: 'none' }} onChange={handlePdfFileChange} />

							</button>

							<button onClick={() => setShowEmojiLoader(!showEmojiLoader)}>
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<g clipPath="url(#clip0_100_12-708464)">
										<path d="M18.8581 9.99255C18.841 13.6626 16.5117 17.0713 13.0405 18.3212C11.285 18.9518 9.36478 19.0313 7.56384 18.52C5.83675 18.0315 4.30283 17.0088 3.14954 15.634C0.763436 12.7763 0.490738 8.56657 2.41667 5.39645C4.32555 2.25475 8.10355 0.573109 11.7111 1.3003C15.3471 2.03318 18.1763 4.99877 18.7558 8.65746C18.8297 9.09492 18.8581 9.54373 18.8581 9.99255C18.8638 10.7254 20 10.7254 19.9943 9.99255C19.9773 5.81686 17.3298 2.03886 13.4155 0.595834C9.51249 -0.847192 4.9448 0.396992 2.30304 3.61255C0.985003 5.21465 0.189634 7.16899 0.0305605 9.24263C-0.134195 11.2992 0.371433 13.407 1.44518 15.1738C3.62676 18.77 7.91039 20.6221 12.0236 19.7926C16.0288 18.9859 19.2671 15.6113 19.875 11.5662C19.9545 11.0493 20 10.5266 20 9.99823C19.9943 9.25967 18.8581 9.25967 18.8581 9.99255Z" fill="#757575" />
										<path d="M6.56964 8.23182C7.26934 8.23182 7.83655 7.6646 7.83655 6.96491C7.83655 6.26521 7.26934 5.698 6.56964 5.698C5.86995 5.698 5.30273 6.26521 5.30273 6.96491C5.30273 7.6646 5.86995 8.23182 6.56964 8.23182Z" fill="#757575" />
										<path d="M7.2684 6.96474C7.25704 7.34538 6.96162 7.66353 6.56961 7.66353C6.18897 7.66353 5.87082 7.35106 5.87082 6.96474C5.87082 6.59546 6.16625 6.28868 6.52984 6.26595C6.93889 6.24323 7.25704 6.57274 7.2684 6.96474C7.29113 7.69193 8.42737 7.69761 8.40464 6.96474C8.38192 6.1921 7.92742 5.51603 7.20023 5.24333C6.49576 4.982 5.6663 5.19788 5.1834 5.77737C4.68913 6.36821 4.59823 7.22039 4.99024 7.89078C5.38224 8.56116 6.15488 8.89067 6.91617 8.76568C7.79107 8.61797 8.38192 7.82828 8.41032 6.96474C8.42737 6.23186 7.29113 6.23754 7.2684 6.96474Z" fill="#757575" />
										<path d="M13.4667 8.23116C14.1915 8.23116 14.779 7.6436 14.779 6.9188C14.779 6.19401 14.1915 5.60645 13.4667 5.60645C12.7419 5.60645 12.1543 6.19401 12.1543 6.9188C12.1543 7.6436 12.7419 8.23116 13.4667 8.23116Z" fill="#757575" />
										<path d="M14.2109 6.91894C14.1825 7.87906 12.7224 7.88475 12.7224 6.91894C12.7224 6.50989 13.0576 6.1747 13.4666 6.1747C13.8871 6.1747 14.1995 6.50989 14.2109 6.91894C14.2336 7.64613 15.3698 7.65182 15.3471 6.91894C15.3244 6.12357 14.8472 5.42478 14.0916 5.1464C13.3757 4.88507 12.5236 5.10664 12.035 5.6918C11.5237 6.30537 11.4328 7.18596 11.8418 7.87338C12.2565 8.56081 13.0576 8.90168 13.8359 8.75397C14.7165 8.58921 15.313 7.78248 15.3358 6.91326C15.3698 6.18607 14.2336 6.18606 14.2109 6.91894Z" fill="#757575" />
										<path d="M14.5859 11.981C14.5859 13.4013 12.5293 14.5943 9.99544 14.5943C7.46163 14.5943 5.40503 13.4013 5.40503 11.981H14.5859Z" fill="#757575" />
										<path d="M14.0176 11.9696C14.0176 12.0094 14.0063 12.1514 14.012 12.1116C14.0176 12.0719 13.9836 12.2253 13.9779 12.2537C13.9722 12.2764 13.9267 12.4071 13.9608 12.3275C13.9324 12.3957 13.8927 12.4639 13.8529 12.532C13.7449 12.7082 13.5575 12.9184 13.3757 13.0604C12.8189 13.4978 12.1088 13.7421 11.4213 13.8842C9.93854 14.191 8.15464 14.0546 6.85364 13.2195C6.70025 13.1229 6.60935 13.049 6.48436 12.9354C6.42187 12.8786 6.36506 12.8161 6.30825 12.7536C6.24007 12.6798 6.24575 12.6798 6.21166 12.6286C6.16621 12.5661 6.12645 12.498 6.09236 12.4298C6.081 12.4071 6.06395 12.3786 6.05259 12.3559C6.01282 12.2707 6.07532 12.4241 6.04691 12.3389C6.02419 12.2707 6.00146 12.1968 5.9901 12.1287C5.97305 12.0605 5.9901 12.1344 5.9901 12.1457C5.98442 12.0889 5.98442 12.0378 5.97874 11.981C5.79126 12.1684 5.59809 12.3616 5.41062 12.5491C8.09783 12.5491 10.785 12.5491 13.4722 12.5491C13.8472 12.5491 14.2165 12.5491 14.5914 12.5491C15.3243 12.5491 15.3243 11.4128 14.5914 11.4128C11.9042 11.4128 9.21702 11.4128 6.52981 11.4128C6.15485 11.4128 5.78557 11.4128 5.41062 11.4128C5.10951 11.4128 4.83681 11.6742 4.84249 11.981C4.87658 13.7194 6.75706 14.6568 8.23417 14.975C10.0635 15.367 12.3303 15.2193 13.8927 14.0887C14.5914 13.5831 15.1425 12.8786 15.1596 11.981C15.1652 11.2424 14.029 11.2424 14.0176 11.9696Z" fill="#757575" />
									</g>
									<defs>
										<clipPath id="clip0_100_12-708464">
											<rect width="20" height="20" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</button>

							<div className="flex items-center gap-3 ml-auto">
								<p className="rubik-400 fs-14">Press enter to send</p>
								<button>
									<svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clipPath="url(#clip0_100_8-025266)">
											<path d="M16 2C16 3.10457 15.0962 4 13.9812 4C12.8663 4 11.9624 3.10457 11.9624 2C11.9624 0.89543 12.8663 -4.87367e-08 13.9812 0C15.0962 4.87364e-08 16 0.895431 16 2Z" fill="#757575" />
											<path d="M10.0188 2C10.0188 3.10457 9.11499 4 8.00002 4C6.88506 4 5.9812 3.10457 5.9812 2C5.9812 0.89543 6.88506 -4.87367e-08 8.00002 0C9.11499 4.87364e-08 10.0188 0.895431 10.0188 2Z" fill="#757575" />
											<path d="M4.03765 2C4.03765 3.10457 3.13379 4 2.01882 4C0.903858 4 -4.82822e-08 3.10457 0 2C4.82823e-08 0.89543 0.903858 -4.87367e-08 2.01882 0C3.13379 4.87364e-08 4.03765 0.895431 4.03765 2Z" fill="#757575" />
										</g>
										<defs>
											<clipPath id="clip0_100_8-025266">
												<rect width="16" height="4" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</button>
							</div>
						</div>
						{
							showEmojiLoader && <EmojiPicker searchDisabled onEmojiClick={handleEmojies} height={200} lazyLoadEmojis={true} width={415} className="custom-emoji-picker" />
						}
					</div>
				</div >
			</div >

			<div id="overlay">
				<span id="close-btn" onClick={closeOverlay}>&times;</span>
				<img src={overlayImage} className="rounded-full" alt="Large Image" />
			</div>
		</>
	)
}

export default ResponsiveChatView
